import "./App.css";
import { RouterProvider } from "react-router";
import { AUTHENTICATION_URL } from "./components/Config";
import { useState, useEffect, useRef, createContext } from "react";
import LoadingBar from "react-top-loading-bar";

import router from "./components/Routes";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBFJCvs0BS3X4W0mDWP2lzf1dxAgs5Rf3s",
  authDomain: "shiva-pdf-36a01.firebaseapp.com",
  projectId: "shiva-pdf-36a01",
  storageBucket: "shiva-pdf-36a01.firebasestorage.app",
  messagingSenderId: "521535053156",
  appId: "1:521535053156:web:8f4bbd00a0eb4c659c6e71",
  measurementId: "G-TTL7QLE0LD",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

//export
export { analytics };

//page context
export const PageContext = createContext();

function App() {
  //state
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  //check if logged in
  const checkIfLoggedin = useRef(false);

  //run for once at startup
  useEffect(() => {
    //check
    //run once
    //at startup
    if (checkIfLoggedin.current === false) {
      //call endpoint to check if logged in
      checkIfUserLoggedInEndpoint();
      //start loading
      startLoading();
      //set
      checkIfLoggedin.current = true;

      console.log("Check if logged in");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkIfLoggedin]);

  //loading progress
  const [progress, setProgress] = useState(0);

  // Function to simulate progress updates
  const startLoading = () => {
    setProgress(30); // Start with some progress
    // Simulate an async operation
    setTimeout(() => {
      setProgress(70);
    }, 500);
  };

  //check if logged in endpoint
  const checkIfUserLoggedInEndpoint = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(AUTHENTICATION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "CHECK_IF_LOGGED_IN",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //scroll to top
        window.scrollTo(0, 0);
        //check
        if (data.success === true) {
          //set token
          localStorage.setItem("access_token", data.token);
          //set
          setIsLoggedIn(data.is_logged_in === "1" ? true : false);
        }

        // Simulate an async operation
        setTimeout(() => {
          //set progress
          setProgress(100);
        }, 500);

        console.log("Response Data:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        // Simulate an async operation
        setTimeout(() => {
          //set progress
          setProgress(100);
        }, 500);
      });
  };

  return (
    <div>
      <LoadingBar
        progress={progress}
        onLoaderFinished={() => setProgress(0)} // Reset on completion
      />
      {/* Router */}
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
